import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
var baseUrl = process.env.VUE_APP_BASE_URL;
export default {
  name: 'jtbwg',
  data() {
    return {
      banners: [],
      datas: [],
      news: [],
      collections: [],
      exhibitions: [],
      activitys: [],
      server: []
    };
  },
  methods: {
    openUrl(url) {
      location.href = url;
    },
    toDetail(tid, title, cid, pageId, fromClass) {
      this.$router.push(`/jasbwgTabs?id=${tid}&title=${title}&cid=${cid}${pageId ? `&pageId=${pageId}` : ''}&wfwid=204489&appIds=2078673&name=jtbwg${fromClass ? '&fromClass=1' : ''}`);
    },
    openDetail(data, index, appId, pageId) {
      this.$router.push(`/jasbwgDetail?cid=${data}&index=${index}${appId ? `&appIds=${appId}` : ''}${pageId ? `&pageId=${pageId}` : ''}&wfwid=204489`);
    },
    clickTab(n) {
      // console.log(n)
      // console.log(this.datas)
      // return
      switch (n) {
        case 1:
          this.$router.push(`/jasbwgDetail?cid=6234873&title=金博简介&pageId=412309&classData=1&wfwfid=204489&cids=2078673`);
          break;
        case 2:
          location.href = 'https://www.720yun.com/t/f6vk6w277f9';
          break;
        case 3:
          location.href = 'https://museum.chaoxing.com/ticket/vtwo/#/ticket/home?museumCode=204489&id=249';
          break;
        case 4:
          location.href = 'https://museum.chaoxing.com/micro-frontend/content/#/collection?formId=312569&fid=204489&uid=61770689&queryId=d4651fe4ae31749aef62a0b48aa9378543f84f8a624d85a8fbc96d67ab7006403955f6b67fbdccd44ca49d8abd5abd5d&selectTotal=0&roleid=217';
          break;
        case 5:
          location.href = 'https://jtqbwg.mh.chaoxing.com/engine2/general/more?t=74ABBE584E0ED93602F6226EA3D32B08F708CF20624B03116EC874E6D8843E7A6208033A0BF147B2A5E8044DF658B1C9';
          break;
      }
    },
    // 获取banner
    getBanner() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=2078672&pageId=412309&wfwfid=204489`).then(res => {
        this.banners = res.data.data.results.map(item => {
          return item.fields[0].value;
        });
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperBanner, {
            pagination: {
              el: '#banner .pagination'
            },
            visibilityFullFit: true,
            loop: true
          });
          new Swiper(this.$refs.swiper1, {
            slidesPerView: 3.2,
            paginationClickable: true,
            //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
            spaceBetween: 0,
            //slide之间的距离（单位px）。
            freeMode: true,
            //默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
            loop: false
          });
        });
      });
    },
    // 获取资讯
    getNewsList() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=2081929&pageId=412309&wfwfid=204489`).then(res => {
        this.news = res.data.data.results.map(item => {
          return {
            title: item.fields[1].value,
            time: item.fields[6].value
          };
        });
      });
    },
    getHeaderList() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/classifies?appIds=1556675&pageId=412309&wfwfid=204489`).then(res => {
        this.datas = res.data.data.classifies.map(item => {
          return {
            name: item.name,
            id: item.id,
            url: item.url,
            pid: item.pid
          };
        });
        console.log(this.datas);
      });
    },
    // 文创
    getServer() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/classifies?appIds=2078673&pageId=412309&wfwfid=204489`).then(res => {
        let datas = res.data.data.classifies.map(item => {
          return {
            name: item.name,
            cid: item.id,
            url: item.url,
            pid: item.pid,
            introduction: item.introduction,
            showType: item.showType
          };
        });
        this.server = datas.filter(d => {
          return d.pid == 6235134;
        });
      });
    },
    // 藏品鉴赏
    getCollectList() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=2078670&pageId=412309&wfwfid=204489`).then(res => {
        let arrs = [];
        this.collections = res.data.data.results.map((item, index) => {
          if (index < 5) {
            arrs.push(this.$ajax(`${baseUrl}/api/micro-backend/front/mh/detail?id=${item.id}`));
          }
          return {
            name: item.fields[1].value
          };
        });
        Promise.all(arrs).then(res => {
          res.map((r, ri) => {
            this.collections[ri].img = r.data.data.extra[100].value;
          });
        });
        this.$nextTick(() => {
          new Swiper(this.$refs.swiper2, {
            slidesPerView: 3.2,
            paginationClickable: true,
            spaceBetween: 0,
            freeMode: true,
            loop: false
          });
        });
      });
    },
    // 展览列表
    getExhibitions() {
      let classifies = [{
        id: 6235111
      }];
      let data = encodeURIComponent(`${JSON.stringify(classifies)}`);
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?pageId=412309&wfwfid=204489&classifies=${data}&pageSize=40&appIds=2078673`).then(res => {
        this.exhibitions = res.data.data.results.map(item => {
          return {
            name: item.fields[1].value,
            img: item.fields[0].value
          };
        });
        this.$nextTick(() => {
          new Swiper(this.$refs.swiper3, {
            slidesPerView: 1.3,
            paginationClickable: true,
            //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
            spaceBetween: 20,
            //slide之间的距离（单位px）。
            freeMode: true,
            //默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
            loop: false
          });
        });
      });
    },
    // 教育
    getActivitys() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=2081849&pageId=412309&wfwfid=204489`).then(res => {
        this.activitys = res.data.data.results.map(item => {
          return {
            name: item.fields[1].value,
            img: item.fields[0].value
          };
        });
      });
    }
  },
  mounted() {
    this.getBanner();
    this.getExhibitions();
    this.getNewsList();
    // this.getHeaderList()
    this.getCollectList();
    this.getActivitys();
    this.getServer();
  },
  created() {
    document.title = '金坛博物馆';
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'js/indexFlex.js';
    document.body.appendChild(script);
  },
  computed: {}
};